import { faEasing, faFontFamily, faMotion } from "@riq/ui/design-tokens";
import { EMBED_THEME_DARK, EMBED_THEME_LIGHT, themeVarsToCssBlock } from "./themes.js";

export const EMBED_STYLES = `
:host {
  display: block;
  font-family: ${faFontFamily.sans};
  --fa-motion-instant: ${faMotion.instant}ms;
  --fa-motion-fast: ${faMotion.fast}ms;
  --fa-motion-base: ${faMotion.base}ms;
  --fa-ease-out: ${faEasing.out};
  --fa-ease-standard: ${faEasing.standard};
${themeVarsToCssBlock(EMBED_THEME_DARK)}
  color: var(--fa-on-surface);
}

:host([theme="light"]) {
${themeVarsToCssBlock(EMBED_THEME_LIGHT)}
}

.card {
  box-sizing: border-box;
  width: 100%;
  max-width: 28rem;
  padding: 20px;
  border-radius: var(--fa-radius-md);
  background: var(--fa-module-bg);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

:host([theme="light"]) .card {
  border: 1px solid var(--fa-outline-variant);
}

.badge {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--fa-on-surface-variant);
}

.badge--live {
  color: var(--fa-live);
}

.track-title {
  margin: 0;
  font-size: 22px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.track-speaker {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--fa-on-surface-variant);
}

.btn {
  box-sizing: border-box;
  width: 100%;
  padding: 14px 20px;
  border: none;
  border-radius: var(--fa-radius-md);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  transition:
    background var(--fa-motion-fast) var(--fa-ease-standard),
    color var(--fa-motion-fast) var(--fa-ease-standard),
    filter var(--fa-motion-fast) var(--fa-ease-standard),
    transform var(--fa-motion-instant) var(--fa-ease-out);
}

.btn:not(:disabled):active {
  transform: scale(0.97);
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.btn--primary {
  background: var(--fa-primary-container);
  color: var(--fa-on-primary);
  border: 1px solid color-mix(in srgb, var(--fa-primary) 50%, transparent);
}

.btn--primary:not(:disabled):hover {
  filter: brightness(1.08);
}

.btn--stop {
  background: var(--fa-error);
  color: var(--fa-on-error);
}

:host([theme="light"]) .btn--stop {
  background: var(--fa-error-container);
}

.btn--offline {
  background: var(--fa-surface-container-highest);
  color: var(--fa-on-surface-variant);
  border: 1px solid var(--fa-outline-variant);
  opacity: 1;
}

.btn--loading {
  filter: brightness(0.92);
}

.error {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: var(--fa-error);
}

.config-error {
  font-size: 14px;
  color: var(--fa-on-surface-variant);
}
.badge,
.track-title,
.track-speaker {
  transition:
    opacity var(--fa-motion-base) var(--fa-ease-out),
    transform var(--fa-motion-base) var(--fa-ease-out);
}

/*
  The player rewrites its text in place, so without this a new track simply replaces the
  old one mid-sentence. The class is applied for one frame before the text changes and
  removed after, giving a short settle rather than a hard cut.
*/
.card.is-changing .badge,
.card.is-changing .track-title,
.card.is-changing .track-speaker {
  opacity: 0;
  transform: translateY(4px);
}

/*
  The shadow root does not inherit the app's reduced-motion handling, so it declares its
  own. Collapsing the duration variables switches off every transition above at once.
*/
@media (prefers-reduced-motion: reduce) {
  :host {
    --fa-motion-instant: 0ms;
    --fa-motion-fast: 0ms;
    --fa-motion-base: 0ms;
  }

  .card.is-changing .badge,
  .card.is-changing .track-title,
  .card.is-changing .track-speaker {
    opacity: 1;
    transform: none;
  }

  .btn:not(:disabled):active {
    transform: none;
  }
}
`;
